import React, { useEffect, useState, useRef } from 'react';
import { Bubble } from 'react-chartjs-2';
import Menu from './Menu';
import { executeQuery } from './executeQuery';
import ReactLoading from "react-loading";

const generateRandomPosition = () => Math.random() * 100;

const generateRandomColor = () => {
  const r = Math.floor(Math.random() * 255);
  const g = Math.floor(Math.random() * 255);
  const b = Math.floor(Math.random() * 255);
  return `rgba(${r}, ${g}, ${b}, 0.5)`;
};

const BubbleChart = ({
}) => {
  
  const bubbleChartRef = useRef(null);
  const [showClusterModal, setShowClusterModal] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [showMenu, setShowMenu] = useState(false); // To toggle the menu
  const [selectedCluster, setSelectedCluster] = useState(null);
  const [currentClusters, setCurrentClusterData] = useState([]); // Clusters at the current level
  const [clusterHierarchy, setClusterHierarchy] = useState([]);
  const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 }); // To position the menu
  const [clusters, setClusters] = useState([]);
  const [loading, setLoading] = useState(false);

  const bubbleDataRef = useRef(null);
  const messageChartRef = useRef(null);
  const trafficChartRef = useRef(null);

  const fetchQuestions = async () => {
    const websiteQuery = `
      SELECT message AS message
      FROM conversation_website
      WHERE role = 'user';
    `;

    const discordQuery = `
      SELECT prompt AS message
      FROM conversations
    `;
  //   try {
  //     const results = await executeQuery(websiteQuery);
  //     const questionList = results.map((row) => row.message);
  //     console.log(questionList)
  //     setQuestions(questionList);
  //   } catch (error) {
  //     console.error("Error fetching questions:", error);
  //   }
  // };

    try {
      const websiteResults = await executeQuery(websiteQuery);
      const discordResults = await executeQuery(discordQuery);
      const combinedResults = [
        ...(websiteResults || []),
        ...( discordResults || []),
    ];
    const questionList = combinedResults
    .filter((row) => row.message !== undefined) // Remove undefined values
    .map((row) => row.message); // Map only valid questions

      console.log("QUESTIONS", questionList)
      setQuestions(questionList);
    } catch (error) {
      console.error("Error fetching questions:", error);
    }
  };

  const clusterQuestions = async () => {
      
      setLoading(true);
      // Development http://localhost:3000
      // Production https://rolo-backend-506573180721.europe-west1.run.app/
      try {
        const response = await fetch("https://rolo-backend-506573180721.europe-west1.run.app/api/cluster", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ questions }), 
        });
  
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
  
        const data = await response.json();
        setClusters(data.clusters);
      } catch (error) {
        console.error("Error clustering questions:", error);
      } finally {
        setLoading(false);
      }
    };

  const closeClusterModal = () => {
    setShowClusterModal(false);
    setTimeout(() => handleChartResize(), 300); 
  };


  const handleViewQuestions = () => {
    setShowClusterModal(true); // Show modal
    setShowMenu(false); // Close menu
  };

  const handleCloseMenu = () => {
    setShowMenu(false); // Hide the menu
  };

  const handleGoBack = () => {
    if (clusterHierarchy.length <= 1) {
      console.error("Already at the top level.");
      return;
    }
  
    setClusterHierarchy((prev) => {
      const newHierarchy = [...prev];
      const previousLevel = newHierarchy.pop();
      setCurrentClusterData(previousLevel); 
      return newHierarchy;
    });
  };

  const wrapText = (text, maxLineLength = 20) => {
    const words = text.split(' ');
    const lines = [];
    let currentLine = '';
  
    for (const word of words) {
      if ((currentLine + word).length > maxLineLength) {
        lines.push(currentLine);
        currentLine = word;
      } else {
        currentLine += (currentLine ? ' ' : '') + word;
      }
    }
    lines.push(currentLine); 
    return lines;
  };
  
  
  const bubbleChartOptions = {
    responsive: true,
    plugins: {
      legend: { display: true },
      tooltip: {
        callbacks: {
          label: (context) => {
            const label = `Cluster ${context.raw.label}: ${context.raw.questions.length} questions`;
            const wrappedLabel = wrapText(label, 30); 
            return wrappedLabel;
          },
        },
      },
    },
    onClick: (event, elements) => {
      if (elements.length > 0) {
        const { clusterId } = elements[0].element.$context.raw;
        handleBubbleClick(clusterId);
      }
    },
    scales: {
      x: {
        grid: {
          display: false, 
        },
        ticks: {
          display: false,
        },
      },
      y: {
        grid: {
          display: false,
        },
        ticks: {
          display: false,
        },
      },
    },
  };

  const handleBubbleClick = (event, elements) => {
    if (elements.length > 0) {
      const { clusterId } = elements[0].element.$context.raw;
      const clickedCluster = currentClusters.find((c) => c.clusterId === clusterId);
      // console.log(cluster)
      if (clickedCluster) {
        if (clusterHierarchy.length === 1) {
          // Top level: Show the menu
          setSelectedCluster(clickedCluster);
          setMenuPosition({
            x: event.native?.clientX + 10 || 10, // Add an offset for better positioning
            y: event.native?.clientY + 10 || 10,
          });
          setShowMenu(true);
        } else if (clusterHierarchy.length > 1) {
          // Second level: Show the questions directly
          setSelectedCluster(clickedCluster);
          setShowClusterModal(true);
        }
      }
    }
  };

  const handleGoToSubClusters = async () => {
    if (!selectedCluster) return;
    try {
      // Production
      // Development http://localhost:3000
      const response = await fetch("https://rolo-backend-506573180721.europe-west1.run.app/api/cluster", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ questions: selectedCluster.questions, k: 5 }),
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      const data = await response.json();
      setClusterHierarchy((prev) => [...prev, currentClusters]);
      setCurrentClusterData(data.clusters); 
      setShowMenu(false); // Close menu
    } catch (error) {
      console.error("Error fetching sub-clusters:", error);
    }
  };
  useEffect(() => {
    const handleResizeEvent = () => {
      handleChartResize();
    };

    window.addEventListener("resize", handleResizeEvent);

    return () => {
      window.removeEventListener("resize", handleResizeEvent);
    };
  }, []);

  useEffect(() => {
    if (clusters.length > 1) {
      setCurrentClusterData(clusters); 
      setClusterHierarchy([clusters]); 
    }
  }, [clusters]);

    useEffect(() => {
      if (clusterHierarchy.length === 0) {
        setClusterHierarchy([currentClusters]);
      } else {
        setClusterHierarchy((prev) => [...prev, currentClusters]); 
      }
      bubbleDataRef.current = {
        datasets: generateBubbleData(),
      };
    }, [currentClusters]);

    useEffect(() => {
      fetchQuestions()
    }, []);
    
  
    useEffect(() => {
  
      clusterQuestions();
    }, [questions]);

    useEffect(() => {
      const handleOutsideClick = (event) => {
        if (showMenu && !event.target.closest('.menu-container')) {
          setShowMenu(false); 
        }
      };
    
      document.addEventListener('click', handleOutsideClick);
    
      return () => {
        document.removeEventListener('click', handleOutsideClick);
      };
    }, [showMenu]);
  
    const bubbleChartData = bubbleDataRef.current || { datasets: [] };
  
    const handleChartResize = () => {
      if (bubbleChartRef.current) {
        bubbleChartRef.current.resize(); 
      }
      if (messageChartRef.current) {
        messageChartRef.current.resize();
      }
      if (trafficChartRef.current) {
        trafficChartRef.current.resize();
      }
    };

    const generateBubbleData = () => {
      const data = currentClusters.map((cluster) => ({
        label: cluster.name.length > 20 
        ? cluster.name.substring(0, 20) + "..." 
        : cluster.name,
        data: [
          {
            x: generateRandomPosition(),
            y: generateRandomPosition(),
            r: cluster.questions.length /4,
            clusterId: cluster.clusterId,
            questions: cluster.questions,
            label: cluster.name
          },
        ],
        backgroundColor: generateRandomColor(),
        borderColor: 'rgba(0, 0, 0, 0.1)',
        borderWidth: 1,
      }));
      // console.log("Generated Bubble Data:", data);
      return data;
    };

    const truncateByWords = (str, wordLimit) => {
      const words = str.split(" ");
      return words.length > wordLimit 
        ? words.slice(0, wordLimit).join(" ") + "..." 
        : str;
    };

  return (
    <div className="mt-5">
      <h4>Topic Clustering</h4>
      {clusterHierarchy.length > 1 && (
        <button className="btn btn-secondary mb-3" onClick={handleGoBack}>
          Back to Previous Level
        </button>
      )}
      {loading ? (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100px" }}>
        <ReactLoading type="spin" color="#3498db" height={50} width={50} />
      </div>
    ) : (
      <div>
                  <Bubble
          ref={bubbleChartRef}
          data={bubbleChartData}
          options={{
            ...bubbleChartOptions,
            onClick: (event, elements) => handleBubbleClick(event, elements),
          }} 
        />
          {showMenu && clusterHierarchy.length === 1 && (
            <Menu
              position={menuPosition}
              onViewQuestions={handleViewQuestions}
              onGoToSubClusters={handleGoToSubClusters}
              onClose={handleCloseMenu}
            />
          )}

          {showClusterModal && selectedCluster && (
            <div className="modal-overlay" onClick={closeClusterModal}>
              <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <h4>{truncateByWords(selectedCluster.name, 20)}</h4>
                <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                  <ul>
                    {selectedCluster.questions.map((question, index) => (
                      <li key={index}>{question}</li>
                    ))}
                  </ul>
                </div>
                <button
                  className="btn btn-outline-secondary"
                  onClick={closeClusterModal}
                >
                  Close
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default BubbleChart;
